import { localisedValue } from "utils"
import { createPrivilegeObject } from "utils/privileges/privilegesMapper"
import store from "../../../store"

const meetingDetailTransformHelper = response => {
  const state = store.getState()
  const user = state.app.user.info
  let status = response?.data?.meetingStatus.key
  let privileges = createPrivilegeObject(response?.data?.privileges)
  let participantList = [
    { ...response?.data?.organizer, host: true, isPresent: status === "in_progress" ? true : false },
    ...response?.data?.attendees.map(e => {
      return {
        ...e,
        isPresent: !e?.absent,
        markedAbsent: !!e?.absent,
      }
    }),
  ]
  let observerList = [
    ...response?.data?.observers.map(e => ({
      ...e,
      isPresent: !!(e.joinedAt && !e.leftAt) ? true : false,
      markedAbsent: !e.joinedAt ? false : e.absent,
    })),
  ]
  let isOrganizer = response?.data?.organizer?.userId === user.id
  let isObserver = response?.data?.observers?.some(item => item?.userId === user?.id)

  return {
    ...response?.data,
    participantList,
    observerList,
    privileges,
    meetingAgendas: response?.data.meetingAgendas.map(e => ({
      id: e?.id,
      title: localisedValue({ object: e, key: "title" }),
      url: e?.config?.url && decodeURIComponent(e?.config?.url),
      ...(!!e.config?.internal && { internal: true }),
    })),
    defaultAgendas: response?.data.meetingDefaultAgendas.map(e => ({
      ...e,
      agendaType: "default",
    })),
    status,
    isOrganizer,
    isObserver,
    aiTotalScore: response?.data?.audioAnalysis?.summary?.assessment?.scoring?.total_score,
  }
}
export default meetingDetailTransformHelper
